import React from "react";
import {
  HeaderContainer,
  HeaderIconsContainer,
  HeaderIconsLinksContainer,
  HeaderLockupImg,
} from "./Header.styles";
import unityLockup from "../../assets/logos/unity-rebrand/unity-horiz-cobranded-tint.svg";

export const BlankHeader: React.FC<{ link: string }> = ({ link }) => {
  const showLogo = import.meta.env.VITE_IS_USER_TESTING_ENV !== "true";

  return (
    <HeaderContainer>
      <HeaderIconsLinksContainer>
        <a href={link} target="_blank" rel="noreferrer">
          <HeaderIconsContainer data-testid="HeaderIcons">
            {showLogo && (
              <HeaderLockupImg src={unityLockup} alt="Unity by BillionToOne" />
            )}
          </HeaderIconsContainer>
        </a>
      </HeaderIconsLinksContainer>
    </HeaderContainer>
  );
};
